import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PublicProjectsLayout.module.css';

interface PublicProjectsLayoutProps {
  children: React.ReactNode;
}

const PublicProjectsLayout: React.FC<PublicProjectsLayoutProps> = ({ children }) => {
  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <Link to="/" className={styles.logoLink} aria-label="Profunding">
          <img src="/Profunding_Azul.png" alt="Profunding" className={styles.logo} />
        </Link>

        <nav className={styles.nav}>
          <Link to="/" className={styles.navLink}>Inicio</Link>
          <Link to="/quienes-somos" className={styles.navLink}>Quienes somos</Link>
          <Link to="/proyectos" className={styles.navLink}>Proyectos</Link>
        </nav>
      </header>

      <main className={styles.main}>{children}</main>
    </div>
  );
};

export default PublicProjectsLayout;
